module.exports = __webpack_public_path__ + "static/media/Debris2Sketch.32e1e367.svg";